export default __webpack_public_path__ + "static/media/file-loader.d7ea25a6.svg";